// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const IntuneMAMSvg = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '284'}
        height={props.height ? props.height.toString() : '173'}
        viewBox='0 0 284 173'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M18.03 4.94443L18.03 25.5L214.53 25.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <ellipse
            cx='3'
            cy='3'
            rx='3'
            ry='3'
            transform='matrix(1 8.74228e-08 8.74228e-08 -1 15.03 6)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <path
            d='M278.655 55.8479L278.655 19.4004L242.882 19.4004'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <circle
            cx='278.655'
            cy='59.2227'
            r='3.37477'
            transform='rotate(180 278.655 59.2227)'
            fill='var(--center-channel-color)'
            fillOpacity='0.48'
        />
        <path
            d='M164.345 66.9186H230.528'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M174.202 75.3676H240.386'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M167.161 85.2247H233.345'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M179.835 102.123H210.814'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M158.711 58.6563H179.834'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M184.058 58.6563H215.038'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M219.262 58.6563H246.018'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M199.549 110.572H226.304'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M179.835 110.572H195.325'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M169.977 93.2667H200.957'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M205.181 93.2665H231.937'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M164.344 50.7246H199.549'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M205.181 50.7246H240.385'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M217.677 75.5825C219.143 75.5826 220.327 76.7619 220.327 78.2231V89.8784C220.327 99.8294 215.863 107.898 205.888 107.898H197.791C187.816 107.898 183.352 99.8294 183.352 89.8784V78.2231C183.352 76.7669 184.541 75.5826 186.002 75.5825H217.677ZM199.852 82.3871V91.5024L201.718 93.3676L199.852 95.2319V97.6948H204.955V87.5463L203.529 86.1205L204.955 84.6938V82.3871H199.852Z'
            fill='var(--button-bg)'
        />
        <path
            d='M202.962 57.1323C210.145 57.1325 215.029 63.2033 215.029 70.6616V75.6411C215.029 77.5321 210.561 77.5346 210.561 75.6411V70.6616C210.561 65.5868 207.636 61.7212 203.619 61.7212H199.253C195.486 61.7214 192.311 65.5869 192.311 70.6616V75.6411C192.311 77.5357 187.852 77.5344 187.852 75.6411V70.6616C187.852 63.2032 192.736 57.1323 199.92 57.1323H202.962Z'
            fill='var(--button-bg)'
        />
        <path
            d='M99.1957 12H200.804L207 151.5H93L99.1957 12Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            width='138'
            height='7.5'
            transform='matrix(1 0 0 -1 81 159)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <rect
            x='51'
            y='3'
            width='196.5'
            height='129'
            rx='6'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='6'
        />
        <path
            d='M40.53 159H108.03V61.53C108.03 57.3713 104.659 54 100.5 54H48.06C43.9013 54 40.53 57.3713 40.53 61.53V159Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            width='48'
            height='55.5'
            rx='7.53'
            transform='matrix(1 0 0 -1 219.03 135)'
            fill='var(--center-channel-color)'
            fillOpacity='0.16'
        />
        <rect
            x='227.758'
            y='76.7439'
            width='49.9482'
            height='94.0884'
            rx='8.71189'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='3.48476'
        />
        <path
            d='M229.5 84.875C229.5 81.3466 232.36 78.4862 235.889 78.4862H269.575C273.103 78.4862 275.963 81.3466 275.963 84.875V86.6173H229.5V84.875Z'
            fill='var(--button-bg)'
            fillOpacity='0.16'
        />
        <path
            d='M237 117H268.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M238.5 121.5H266.927'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M237 126L270 126'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M237 144L270 144'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M238.5 135L267.005 135'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M234 112.5H241.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M244.5 112.5H257.806'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M245.5 148.5H258.806'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M261 112.5H272.492'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M251.54 139.5H263.032'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M241.647 139.5H248.3'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M238.5 130.5H251.806'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M255 130.5H266.492'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M237 108H250.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M253.5 108H268.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M262.27 121.46C263.153 121.46 263.866 122.17 263.867 123.05V130.071C263.867 136.065 261.177 140.924 255.169 140.924H250.292C244.285 140.924 241.596 136.064 241.596 130.071V123.05C241.596 122.173 242.312 121.461 243.192 121.46H262.27ZM251.535 125.559V131.049L252.658 132.172L251.535 133.295V134.779H254.608V128.667L253.749 127.808L254.608 126.949V125.559H251.535Z'
            fill='var(--button-bg)'
        />
        <path
            d='M253.407 110.348C257.734 110.348 260.675 114.004 260.675 118.496V121.495C260.675 122.634 257.984 122.636 257.984 121.495V118.496C257.984 115.44 256.222 113.111 253.803 113.111H251.174C248.905 113.111 246.992 115.44 246.992 118.496C246.992 118.496 246.992 120.354 246.992 121.495C246.992 122.637 244.307 122.636 244.307 121.495V118.496C244.307 114.004 247.249 110.348 251.575 110.348H253.407Z'
            fill='var(--button-bg)'
        />
        <circle
            cx='150'
            cy='67.5'
            r='52.5'
            fill='var(--button-bg)'
            fillOpacity='0.04'
        />
        <g clipPath='url(#clip0_3753_1225)'>
            <mask
                id='mask0_3753_1225'
                style={{maskType: 'luminance'}}
                maskUnits='userSpaceOnUse'
                x='120'
                y='37'
                width='60'
                height='61'
            >
                <path
                    d='M120 37.5H180V97.5H120V37.5Z'
                    fill='white'
                />
            </mask>
            <g mask='url(#mask0_3753_1225)'>
                <path
                    d='M120 46.5675C120 38.9044 130.02 34.7096 136.64 39.601L151.03 50.2275L163.174 43.3458C169.593 39.8457 179.878 42.3563 180 51.9239V87.1833C180 94.8464 170.274 98.8416 163.655 93.9497L149.002 83.0907L136.843 89.9742C130.364 93.5077 120.01 90.7969 120.01 81.4852C120.01 70.3088 120 74.6002 120 46.5685V46.5675Z'
                    fill='url(#paint0_linear_3753_1225)'
                />
                <path
                    d='M120 46.5675C120 38.9044 130.02 34.7096 136.64 39.601L151.03 50.2275L163.174 43.3458C169.593 39.8457 179.878 42.3563 180 51.9239V87.1833C180 94.8464 170.274 98.8416 163.655 93.9497L149.002 83.0907L136.843 89.9742C130.364 93.5077 120.01 90.7969 120.01 81.4852C120.01 70.3088 120 74.6002 120 46.5685V46.5675Z'
                    fill='url(#paint1_radial_3753_1225)'
                />
                <path
                    d='M120 46.5675C120 38.9044 130.02 34.7096 136.64 39.601L151.03 50.2275L163.174 43.3458C169.593 39.8457 179.878 42.3563 180 51.9239V87.1833C180 94.8464 170.274 98.8416 163.655 93.9497L149.002 83.0907L136.843 89.9742C130.364 93.5077 120.01 90.7969 120.01 81.4852C120.01 70.3088 120 74.6002 120 46.5685V46.5675Z'
                    fill='url(#paint2_radial_3753_1225)'
                />
                <path
                    d='M136.64 39.601C130.02 34.7096 120 38.9044 120 46.5675V81.0516C120 80.2135 120.427 78.5442 120.427 78.5442C122.401 72.0905 130.794 69.6708 136.601 73.9238L163.654 93.9502C170.274 98.8416 180 94.8464 180 87.1833V51.9239C180 58.47 171.443 65.0414 163.36 59.3475L136.64 39.601Z'
                    fill='url(#paint3_radial_3753_1225)'
                />
                <path
                    d='M136.64 39.601C130.02 34.7096 120 38.9044 120 46.5675V81.0516C120 80.2135 120.427 78.5442 120.427 78.5442C122.401 72.0905 130.794 69.6708 136.601 73.9238L163.654 93.9502C170.274 98.8416 180 94.8464 180 87.1833V51.9239C180 58.47 171.443 65.0414 163.36 59.3475L136.64 39.601Z'
                    fill='url(#paint4_radial_3753_1225)'
                    fillOpacity='0.25'
                />
                <path
                    d='M136.64 39.601C130.02 34.7096 120 38.9044 120 46.5675V81.0516C120 80.2135 120.427 78.5442 120.427 78.5442C122.401 72.0905 130.794 69.6708 136.601 73.9238L163.654 93.9502C170.274 98.8416 180 94.8464 180 87.1833V51.9239C180 58.47 171.443 65.0414 163.36 59.3475L136.64 39.601Z'
                    fill='url(#paint5_radial_3753_1225)'
                    fillOpacity='0.55'
                />
                <path
                    d='M136.64 59.1434C130.02 54.2515 120 58.4468 120 66.1099V46.5677C120 38.9037 130.02 34.7088 136.64 39.6002L163.36 59.3468C171.443 65.0412 180 58.4698 180 51.9237V71.9234C180 79.5865 169.98 83.7813 163.36 78.8899L136.64 59.1434Z'
                    fill='url(#paint6_linear_3753_1225)'
                />
                <path
                    d='M136.64 59.1434C130.02 54.2515 120 58.4468 120 66.1099V46.5677C120 38.9037 130.02 34.7088 136.64 39.6002L163.36 59.3468C171.443 65.0412 180 58.4698 180 51.9237V71.9234C180 79.5865 169.98 83.7813 163.36 78.8899L136.64 59.1434Z'
                    fill='url(#paint7_radial_3753_1225)'
                    fillOpacity='0.36'
                />
            </g>
        </g>
        <rect
            x='99.75'
            y='42.75'
            width='127.5'
            height='97.5'
            rx='5.63698'
            transform='rotate(90 99.75 42.75)'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='4.5'
        />
        <path
            d='M4.5 46.4559C4.5 45.6518 5.15182 45 5.95588 45H96.0441C96.8482 45 97.5 45.6518 97.5 46.4559V54H4.5V46.4559Z'
            fill='var(--button-bg)'
            fillOpacity='0.16'
        />
        <path
            d='M61.4471 101.888C62.3956 101.888 63.1618 102.651 63.162 103.596V111.138C63.162 117.577 60.2733 122.798 53.8192 122.798H48.58C42.1259 122.798 39.2372 117.577 39.2372 111.138V103.596C39.2374 102.654 40.0068 101.888 40.952 101.888H61.4471ZM49.9139 106.291V112.19L51.12 113.396L49.9139 114.602V116.197H53.2157V109.629L52.2928 108.707L53.2157 107.784V106.291H49.9139Z'
            fill='var(--button-bg)'
        />
        <path
            d='M51.9254 89.9496C56.5733 89.9496 59.7339 93.8775 59.7339 98.7036V101.926C59.7334 103.149 56.8439 103.151 56.8433 101.926V98.7036C56.8433 95.4199 54.9506 92.9194 52.3511 92.9194H49.5259C47.0888 92.9194 45.0338 95.4199 45.0338 98.7036C45.0338 98.7036 45.0338 100.7 45.0338 101.926C45.0332 103.152 42.1496 103.151 42.149 101.926V98.7036C42.149 93.8775 45.3096 89.9496 49.9576 89.9496H51.9254Z'
            fill='var(--button-bg)'
        />
        <path
            d='M23.9415 94.5H75.9138'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M26.4163 99H73.3185'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M23.9413 103.5L78.3885 103.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M23.9413 121.5L78.3885 121.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M26.4163 112.5L73.4468 112.5'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M18.9916 90H31.366'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M36.3157 90H58.27'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M38.2906 126H60.2448'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M63.5393 90H82.4998'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M47.9312 117H66.8917'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M31.6083 117H42.5854'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M26.4163 108H48.3705'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M53.6398 108H72.6003'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M23.9413 85.5H46.2152'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path
            d='M51.165 85.5H75.9137'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.12'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <defs>
            <linearGradient
                id='paint0_linear_3753_1225'
                x1='145.622'
                y1='96.0938'
                x2='167.036'
                y2='50.2744'
                gradientUnits='userSpaceOnUse'
            >
                <stop
                    offset='0.02'
                    stopColor='#1169DA'
                />
                <stop
                    offset='0.435'
                    stopColor='#0151BD'
                />
                <stop
                    offset='0.614'
                    stopColor='#014DB7'
                />
                <stop
                    offset='1'
                    stopColor='#126AD9'
                />
            </linearGradient>
            <radialGradient
                id='paint1_radial_3753_1225'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(173.696 29.3841) rotate(110.224) scale(43.8371 32.8375)'
            >
                <stop
                    offset='0.423'
                    stopColor='#004AFF'
                    stopOpacity='0.1'
                />
                <stop
                    offset='0.729'
                    stopColor='#014DB9'
                />
                <stop
                    offset='0.836'
                    stopColor='#014DB9'
                    stopOpacity='0.9'
                />
                <stop
                    offset='0.955'
                    stopColor='#014DB9'
                    stopOpacity='0'
                />
            </radialGradient>
            <radialGradient
                id='paint2_radial_3753_1225'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(128.01 94.3032) rotate(-73.6432) scale(34.9002 42.5128)'
            >
                <stop
                    offset='0.091'
                    stopColor='#004AFF'
                    stopOpacity='0.1'
                />
                <stop
                    offset='0.56'
                    stopColor='#014DB9'
                />
                <stop
                    offset='0.749'
                    stopColor='#014DB9'
                    stopOpacity='0.99'
                />
                <stop
                    offset='1'
                    stopColor='#014DB9'
                    stopOpacity='0'
                />
            </radialGradient>
            <radialGradient
                id='paint3_radial_3753_1225'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(185.814 37.5) rotate(134.068) scale(84.5934 65.1563)'
            >
                <stop
                    offset='0.249'
                    stopColor='#23C0FE'
                />
                <stop
                    offset='0.717'
                    stopColor='#23C0FE'
                />
                <stop
                    offset='0.995'
                    stopColor='#1C91FF'
                />
            </radialGradient>
            <radialGradient
                id='paint4_radial_3753_1225'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(137.891 42.2564) rotate(45.9092) scale(60.5184 14.3969)'
            >
                <stop
                    offset='0.165'
                    stopColor='#096DD6'
                    stopOpacity='0'
                />
                <stop
                    offset='0.484'
                    stopColor='#096DD6'
                />
                <stop
                    offset='0.901'
                    stopColor='#0876DE'
                    stopOpacity='0.814'
                />
                <stop
                    offset='1'
                    stopColor='#029AFF'
                    stopOpacity='0'
                />
            </radialGradient>
            <radialGradient
                id='paint5_radial_3753_1225'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(177.764 73.4433) rotate(91.61) scale(9.71986 8.75334)'
            >
                <stop stopColor='#0068B3'/>
                <stop
                    offset='0.93'
                    stopColor='#006CB8'
                    stopOpacity='0'
                />
            </radialGradient>
            <linearGradient
                id='paint6_linear_3753_1225'
                x1='137.105'
                y1='51.3181'
                x2='147.207'
                y2='94.2443'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#92EEFE'/>
                <stop
                    offset='0.565'
                    stopColor='#35DDFF'
                />
                <stop
                    offset='1'
                    stopColor='#08B1F9'
                />
            </linearGradient>
            <radialGradient
                id='paint7_radial_3753_1225'
                cx='0'
                cy='0'
                r='1'
                gradientUnits='userSpaceOnUse'
                gradientTransform='translate(130.064 37.4999) rotate(69.461) scale(14.9496 12.0748)'
            >
                <stop
                    stopColor='#CCF9FF'
                    stopOpacity='0.93'
                />
                <stop
                    offset='1'
                    stopColor='#35DDFF'
                />
            </radialGradient>
            <clipPath id='clip0_3753_1225'>
                <rect
                    width='60'
                    height='60'
                    fill='white'
                    transform='translate(120 37.5)'
                />
            </clipPath>
        </defs>
    </svg>
);

export default IntuneMAMSvg;
